import { jsx as _jsx } from "react/jsx-runtime";

const LinkSectionItem = _ref => {
  let {
    text,
    url,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("li", {
    className: "main-footer__links-section-row",
    children: /*#__PURE__*/_jsx("a", {
      className: "main-footer__links-section-link",
      href: url,
      onClick: onClick,
      children: text
    })
  });
};

export default LinkSectionItem;